import { DocumentStatus, GenericObject, OrderType, copyFields, fixDates } from '@synergy/models';
import { Media } from '@synergy/models';

import { Contact } from '../../../common/models/contact';
import { Customer } from '../../../common/models/customer';
import { SalesOrderPosition } from './salesOrder-position';
import { Supplier } from '../../../common/models/supplier';
import { User } from '../../../common/models/user';

export class SalesOrder {
    public id!: number;
    public number!: string;
    public internalNote?: string;
    public type!: OrderType;
    public status!: DocumentStatus;
    public responsibleContact!: Contact;
    public customerContact?: Contact;
    public customerAccount?: Customer;
    /** Every supplier on the positions, once; only the list carries it. */
    public supplierNames?: string[];
    /** The same suppliers with their account, for the card in the list (#2260). */
    public suppliers?: Supplier[];
    /** Only the list carries it. */
    public totalNetPrice?: number;
    public positions!: SalesOrderPosition[];
    public media!: Media[];
    public dueDate!: Date;
    public generatesPurchaseOrder!: boolean;
    public noteFromCustomer?: string;

    public createdAt!: Date;
    public updatedAt?: Date;
    public createdBy!: User;
    public updatedBy?: User;

    public static fromPlainObject(object: GenericObject): SalesOrder {
        const salesOrder = new SalesOrder();

        copyFields(object, salesOrder);

        if (object['responsibleContact']) {
            salesOrder.responsibleContact = Contact.fromPlainObject(object['responsibleContact']);
        }

        if (object['customerContact']) {
            salesOrder.customerContact = Contact.fromPlainObject(object['customerContact']);
        }

        if (object['customerAccount']) {
            salesOrder.customerAccount = Customer.fromPlainObject(object['customerAccount']);
        }

        if (object['positions']) {
            salesOrder.positions = object['positions'].map(SalesOrderPosition.fromPlainObject);
        }

        if (object['media']) {
            salesOrder.media = object['media'].map(Media.fromPlainObject);
        }

        fixDates(salesOrder, ['createdAt', 'updatedAt', 'dueDate']);

        return salesOrder;
    }
}
